export const SKILLS = [
  "Javascript",
  "Typescript",
  "Python",
  "Java",
  "C",
  "C++",
  "C#",
  "Go",
  "Rust",
  "Swift",
  "Kotlin",
  "Php",
  "Ruby",
  "Sql",
  "Nosql",
  "Graphql",
  "Rest api development",
  "Microservices architecture",
  "System design",
  "Data structures",
  "Algorithms",
  "Html5",
  "Css3",
  "Sass",
  "Tailwind css",
  "Bootstrap",
  "React.js",
  "Next.js",
  "Angular",
  "Vue.js",
  "Redux",
  "Responsive design",
  "Web accessibility",
  "Cross browser compatibility",
  "Performance optimization",
  "Node.js",
  "Express.js",
  "Django",
  "Flask",
  "Spring boot",
  "Laravel",
  "Asp.net",
  "Authentication",
  "Oauth",
  "Jwt",
  "Api security",
  "Redis",
  "Kafka",
  "Rabbitmq",
  "Aws",
  "Azure",
  "Google cloud",
  "Docker",
  "Kubernetes",
  "Ci/cd",
  "Jenkins",
  "Github actions",
  "Terraform",
  "Serverless architecture",
  "Mysql",
  "Postgresql",
  "Mongodb",
  "Firebase",
  "Data modeling",
  "Etl",
  "Data warehousing",
  "Big data",
  "Data analysis",
  "Data visualization",
  "Power bi",
  "Tableau",
  "Machine learning",
  "Deep learning",
  "Nlp",
  "Computer vision",
  "Tensorflow",
  "Pytorch",
  "Feature engineering",
  "Statistics",
  "Predictive modeling",
  "Android development",
  "Ios development",
  "React native",
  "Flutter",
  "Mobile ui design",
  "App deployment",
  "Ui design",
  "Ux research",
  "Wireframing",
  "Prototyping",
  "Figma",
  "Adobe xd",
  "Photoshop",
  "Illustrator",
  "Motion design",
  "Branding",
  "Project management",
  "Product management",
  "Agile",
  "Scrum",
  "Business analysis",
  "Stakeholder management",
  "Risk management",
  "Strategic planning",
  "Digital marketing",
  "Seo",
  "Sem",
  "Content marketing",
  "Social media marketing",
  "Email marketing",
  "Affiliate marketing",
  "Influencer marketing",
  "Brand strategy",
  "Sales strategy",
  "Negotiation",
  "Crm",
  "Lead generation",
  "Customer success",
  "Customer support",
  "Financial analysis",
  "Budgeting",
  "Forecasting",
  "Accounting",
  "Taxation",
  "Auditing",
  "Investment analysis",
  "Talent acquisition",
  "Employee engagement",
  "Payroll management",
  "Hr policies",
  "Training and development",
  "Communication",
  "Leadership",
  "Problem solving",
  "Critical thinking",
  "Decision making",
  "Time management",
  "Adaptability",
  "Creativity",
  "Emotional intelligence",
  "Teamwork",
  "Copywriting",
  "Technical writing",
  "Blogging",
  "Script writing",
  "Editing",
  "Proofreading",
  "Storytelling",
  "2Nd / 3Rd / 4Th Officer",
  "2Nd Assistant Cameraman / Clapper / Loader (Data Wrangling)",
  "3Rd / 4Th / 5Th Engineer",
  "Account Operations Analyst",
  "Account Operations Manager",
  "Accountancy",
  "Accountant / Senior Accounts Executive",
  "Accounting Executive",
  "Accounts Executive / Accounts Assistant",
  "Admission And Ticketing Crew",
  "Adult Education",
  "Adult Education / Learning Management",
  "Advisory",
  "Advisory And Advocacy",
  "Aerospace",
  "Agency Director / Segment Lead",
  "Agency Manager / Team Lead",
  "Agriculture",
  "Agriculture / Aquaculture",
  "Agriculture Technician",
  "Agriculturist",
  "Agrifood",
  "Air Transport",
  "Aircraft Engine / Component Maintenance",
  "Aircraft Maintenance",
  "Aircraft Maintenance Engineer Apprentice",
  "Airport Emergency Assistant Manager",
  "Airport Emergency Manager",
  "Airport Emergency Officer",
  "Airport Emergency Officer (Specialist)",
  "Airport Emergency Services",
  "Airport Engineering",
  "Airport Operations",
  "Airport Operations Centre Manager",
  "Airside Duty Manager",
  "Airside Officer",
  "Airside Operations",
  "Analyst - Analytics And Customer Insights",
  "Animator",
  "Application Chemist",
  "Applications Support Engineer",
  "Aquaculture",
  "Aquaculture Technician",
  "Aquaculturist",
  "Arboriculture",
  "Arboriculture / Horticulture And Turf Maintenance / Nursery",
  "Arboriculture Supervisor / Arboriculture Team Leader",
  "Arboriculture Technician",
  "Arborist / Arboricultural Consultant",
  "Architect",
  "Architectural Assistant",
  "Architectural Associate",
  "Architectural Consultancy And Design",
  "Architectural Executive",
  "Area Manager / District Manager",
  "Art Department Assistant / Set Dresser",
  "Art Director",
  "Artificial Intelligence / Machine Learning Engineer",
  "Artificial Intelligence Applied Researcher",
  "Arts",
  "Arts Education",
  "Arts Education Researcher",
  "Arts Educator",
  "Arts Instructor",
  "Assessor",
  "Assistant / Trainee Sales And Purchase Broker",
  "Assistant Arts Instructor",
  "Assistant Chartering Broker / Trainee Chartering Broker",
  "Assistant Concierge",
  "Assistant Coordination And Reservations Executive",
  "Assistant Costume Designer",
  "Assistant Crewing Manager",
  "Assistant Design Engineer",
  "Assistant Director",
  "Assistant Director / Senior Manager",
  "Assistant Director Of Nursing (Clinical)",
  "Assistant Director Of Nursing (Education)",
  "Assistant Director Of Nursing (Management)",
  "Assistant Education And Programmes Executive",
  "Assistant Engineer / Assistant Maintenance Manager",
  "Assistant Engineer / Associate Engineer",
  "Assistant Engineer / Officer (Engineering Procurement)",
  "Assistant Engineer / Officer (Project Development)",
  "Assistant Engineer / Senior Technician (Commissioning)",
  "Assistant Engineer / Service Engineer",
  "Assistant Equipment Engineer",
  "Assistant Event Executive / Assistant Project Executive",
  "Assistant Event Operations Executive",
  "Assistant Event Services Executive",
  "Assistant Executive Housekeeper",
  "Assistant Facilities Engineer",
  "Assistant Food Technologist",
  "Assistant Head Chef",
  "Assistant Horticulturist",
  "Assistant Integration Engineer",
  "Assistant Keeper / Assistant Aquarist",
  "Assistant Lighting Designer",
  "Assistant Manager",
  "Assistant Manager (Network Planning)",
  "Assistant Manager / Senior Engineer (Project Development)",
  "Assistant Manufacturing Manager / Section Manager",
  "Assistant Marine Superintendent",
  "Assistant Marketing Executive",
  "Assistant Multimedia Designer",
  "Assistant Nurse Clinician",
  "Assistant Pastry Chef",
  "Assistant Pastry Cook / Assistant Baker / Kitchen Assistant",
  "Assistant Process Engineer",
  "Assistant Producer - Broadcast (Casting)",
  "Assistant Producer - Film (Casting)",
  "Assistant Producer - Games",
  "Assistant Producer - News / Current Affairs",
  "Assistant Product And Experience Development Executive",
  "Assistant Product Engineer",
  "Assistant Production Engineer",
  "Assistant Project Manager / Project Management Executive",
  "Assistant Quality Assurance / Quality Control Engineer",
  "Assistant Quality Engineer",
  "Assistant Quantity Surveyor / Assistant Cost Manager",
  "Assistant Relationship Manager - Private Banking",
  "Assistant Relationship Manager / Relationship Associate",
  "Assistant Research Director",
  "Assistant Research Executive",
  "Assistant Set Designer",
  "Assistant Specialist (Digital Delivery)",
  "Assistant Sponsorship Executive",
  "Assistant Stage Manager",
  "Assistant Technical Superintendent",
  "Assistant Venue Operations Executive",
  "Assistant Wealth Planner",
  "Associate (Corporate)",
  "Associate (Disputes)",
  "Associate / Assistant Sound Designer",
  "Associate Applications Support Engineer",
  "Associate Business Analyst",
  "Associate Counsellor",
  "Associate Data Centre Operations Engineer",
  "Associate Database Support Engineer",
  "Associate Director (Facilities Management)",
  "Associate Embedded Systems Engineer",
  "Associate Infrastructure Engineer",
  "Associate Infrastructure Support Engineer",
  "Associate Network Engineer",
  "Associate Operations Centre Support Engineer",
  "Associate Product Analyst",
  "Associate Product Designer",
  "Associate Product Manager",
  "Associate Psychologist",
  "Associate Radio Frequency Engineer",
  "Associate Security Analyst",
  "Associate Software Engineer",
  "Associate Systems Support Engineer",
  "Associate Ui Designer",
  "Associate Ux Designer",
  "Associate, Performance And Rewards",
  "Assurance",
  "Attractions Management And Operations",
  "Attractions Operations Director",
  "Attractions Operations Manager",
  "Audit Associate / Audit Assistant Associate",
  "Audit Manager",
  "Audit Partner / Audit Director",
  "Audit Senior",
  "Automation And Orchestration Engineer",
  "Automation Coordinator / Robot Coordinator",
  "Automation Specialist",
  "Automation Technician",
  "Auxiliary Police",
  "Auxiliary Police Officer",
  "Auxiliary Police Officer Supervisor / Team Leader",
  "Back End Developer",
  "Baggage Services",
  "Baggage Services Assistant",
  "Baggage Services Officer",
  "Baker",
  "Barista",
  "Barista Supervisor / Senior Barista",
  "Bartender",
  "Bartender Supervisor",
  "Battery Energy Storage Systems",
  "Beginning Early Intervention Educator",
  "Beginning Early Intervention Teacher",
  "Beginning Early Years Educator",
  "Beginning Infant Educator",
  "Beginning Preschool Educator",
  "Bell Captain",
  "Bellhop / Bell Attendant",
  "Bess Bms Research And Development Engineer",
  "Bess Electrochemistry Research And Development Engineer",
  "Bess Engineer",
  "Bess Quality Assurance And Certification Engineer",
  "Bess Test And Commissioning Engineer",
  "Beverage Service",
  "Billing And Settlement Executive",
  "Billing And Settlement Senior Executive",
  "Biopharmaceuticals Manufacturing",
  "Bioprocess Engineer (Food Applications)",
  "Boom Operator",
  "Branch Manager",
  "Brand Associate / Assistant",
  "Brand Director",
  "Brand Executive / Customer Loyalty Executive",
  "Brand Management",
  "Brand Manager / Customer Loyalty Manager",
  "Branding, Marketing And Communications",
  "Broker / Business Development Executive - Brokers",
  "Brokerage Supervisor / Freight Supervisor",
  "Building Officer / Facilities Officer / Property Officer",
  "Building Supervisor",
  "Built Environment",
  "Bus Captain",
  "Bus Fleet Engineering",
  "Bus Operations",
  "Bus Operations Control Centre Manager",
  "Business",
  "Business Analyst / Artificial Intelligence Translator",
  "Business Analyst / Market Research Analyst / Market Analyst",
  "Business Architect",
  "Business Controller / Finance Director",
  "Business Development",
  "Business Development Director",
  "Business Development Manager",
  "Business Development Manager - Brokers",
  "Business Development, Sales, Sponsorships And Marketing",
  "Business Intelligence Director",
  "Business Intelligence Manager",
  "Business Manager",
  "Business Manager (Asset Management)",
  "Business Manager (Investment Banking)",
  "Business Manager (Private Banking And Wealth Management)",
  "Business Process Improvement Executive",
  "Business Valuation",
  "Business Valuation Associate / Business Valuation Executive",
  "Business Valuation Manager",
  "Business Valuation Partner / Business Valuation Director",
  "Business-To-Business Sales And Key Accounts Executive",
  "Business-To-Business Sales And Key Accounts Manager",
  "Business-To-Customer Sales Executive",
  "Business-To-Customer Sales Manager",
  "Business-To-Customer Sales Senior Executive",
  "Butler / Club Floor Officer / Club Floor Agent",
  "Cabin Crew",
  "Cabin Crew Executive",
  "Cabin Crew Manager",
  "Cabin Crew Team Lead / Cabin Crew Auditor",
  "Cabin Operations",
  "Capability Building",
  "Capability Building Director / Assistant Director",
  "Capability Building Manager / Assistant Manager",
  "Capability Building Senior Executive / Executive",
  "Capacity Management Executive",
  "Capacity Manager",
  "Captain",
  "Carbon Accountant",
  "Carbon Auditor",
  "Carbon Investment Specialist",
  "Carbon Project Developer",
  "Carbon Project Development",
  "Carbon Services And Trading",
  "Carbon Trader",
  "Carbon Verifier",
  "Care And Programme",
  "Care Staff",
  "Cargo Assistant",
  "Cargo Officer",
  "Cargo Operations",
  "Casl Skills",
  "Cat A Certifying Technician",
  "Catering Assistant",
  "Catering Officer",
  "Catering Services",
  "Centre Director / Head Of Institute",
  "Centre Leader",
  "Centre Manager",
  "Channel Sales Manager",
  "Chartering Broker",
  "Chartering Manager",
  "Chef Concierge / Assistant Chef Concierge",
  "Chief Audit Executive / Head Of Internal Audit",
  "Chief Bus Captain / Master Bus Captain",
  "Chief Chemist / Fellow",
  "Chief Controller / Controller",
  "Chief Counsellor",
  "Chief Data Officer / Chief Artificial Intelligence Officer",
  "Chief Digital Officer",
  "Chief Editor",
  "Chief Engineer",
  "Chief Engineer (Special Limit)",
  "Chief Engineer / 2Nd Engineer",
  "Chief Engineer / Chief Technology Officer",
  "Chief Engineer / Fellow",
  "Chief Engineer / Senior Engineering Manager (Power)",
  "Chief Engineer / Senior Engineering Manager (Rolling Stock)",
  "Chief Executive / Managing Director",
  "Chief Executive Officer / Executive Director",
  "Chief Executive Officer / General Manager / President",
  "Chief Executive Officer / Managing Director",
  "Chief Financial Officer",
  "Chief Human Resource Officer",
  "Chief Information Officer",
  "Chief Information Security Officer",
  "Chief Nurse",
  "Chief Pilot (Vice President)",
  "Chief Product Officer",
  "Chief Psychologist",
  "Chief Research And Development Officer",
  "Chief Research Psychologist",
  "Chief Security Officer",
  "Chief Technology Officer",
  "Civil And Structural Engineer",
  "Claims Appraiser / Claims Examiner / Claims Executive",
  "Claims Liaison Executive",
  "Claims Liaison Manager",
  "Claims Manager",
  "Cleaning Operations",
  "Cleaning Operations Executive",
  "Cleaning Operations Manager",
  "Cleaning Supervisor",
  "Client Executive / Account Management Executive",
  "Client Implementation Analyst",
  "Client Implementation Manager",
  "Client Investment Performance And Reporting Analyst",
  "Client Portfolio Analyst",
  "Client Portfolio Manager",
  "Client Service Manager / Client Support Service Manager",
  "Client Service Officer / Client Support Service Officer",
  "Client Support Manager / Account Manager",
  "Cluster Manager",
  "Commanding Officer",
  "Commodities Trader",
  "Commodities Trading Manager / Senior Commodities Trader",
  "Communication Controller",
  "Community Care",
  "Community Care Associate",
  "Community Development Executive",
  "Community Development Specialist",
  "Compliance Advisory Executive",
  "Compliance Advisory Manager",
  "Compliance Analyst",
  "Concierge",
  "Construction Management",
  "Construction Management (Production)",
  "Content And Experience Development Executive / Curator",
  "Content Post Production",
  "Content Production And Management",
  "Content Strategist",
  "Content Writer",
  "Contract Specialist",
  "Cook / Kitchen Assistant",
  "Coordination And Reservations Executive",
  "Corporate",
  "Costume Coordinator",
  "Costume Designer",
  "Counselling",
  "Counselling Educator",
  "Counsellor",
  "Courseware Developer",
  "Creative",
  "Creative Director / Creative Supervisor / 3D Art Supervisor",
  "Creative Technologist",
  "Credit And Lending Operations Analyst",
  "Credit And Lending Operations Analyst (Corporate Banking)",
  "Credit And Lending Operations Analyst (Retail Banking)",
  "Credit And Lending Operations Manager",
  "Credit And Lending Operations Manager (Corporate Banking)",
  "Credit And Lending Operations Manager (Retail Banking)",
  "Credit Manager",
  "Credit Risk Analyst",
  "Credit Risk Analyst (Corporate Banking)",
  "Credit Risk Analyst (Investment Banking)",
  "Credit Risk Analyst (Private Banking And Wealth Management)",
  "Credit Risk Analyst (Retail Banking)",
  "Credit Risk Manager",
  "Credit Risk Manager (Corporate Banking)",
  "Credit Risk Manager (Investment Banking)",
  "Credit Risk Manager (Private Banking And Wealth Management)",
  "Credit Risk Manager (Retail Banking)",
  "Crew Manager",
  "Crew-In-Charge",
  "Crewing Executive",
  "Crewing Manager",
  "Culinary Arts",
  "Curriculum / Pedagogy Specialist",
  "Curriculum Lead",
  "Customer Experience Executive / User Experience Executive",
  "Customer Experience Manager / User Experience Manager",
  "Customer Service Executive",
  "Customer Service Manager",
  "Customer Service Officer / Bank Teller",
  "Customer Service Officer / Rover",
  "Customer Service Officer / Service Quality Analyst",
  "Customer Service Senior Executive",
  "Customer Service, Billing And Settlement Department Manager",
  "Customer Service, Billing And Settlement Manager",
  "Customer Services",
  "Customer Services Agent",
  "Customer Services Officer",
  "Customer Success Director",
  "Customer Success Manager",
  "Cyber Risk Analyst",
  "Cyber Risk Manager",
  "Cyber Security",
  "Data Analyst",
  "Data Analyst / Associate Data Engineer",
  "Data And Artificial Intelligence",
  "Data Architect",
  "Data Centre Operations Engineer",
  "Data Engineer",
  "Data Protection Executive",
  "Data Protection Officer",
  "Data Scientist",
  "Data Scientist / Artificial Intelligence Scientist",
  "Database Support Engineer",
  "Decarbonisation Consultant",
  "Deck Officer (Special Limit)",
  "Demand Management Data Analyst",
  "Demand Management Manager",
  "Demurrage Manager / Laytime Manager / Post Fixture Manager",
  "Depot Operations Manager / Depot Manager",
  "Depot Train Controller",
  "Deputy Bus Operations Control Centre Manager",
  "Deputy Centre Leader",
  "Deputy Chief Pilot / Management Pilot",
  "Deputy Director / Senior Assistant Director",
  "Deputy Director Of Nursing (Clinical)",
  "Deputy Director Of Nursing (Education)",
  "Deputy Director Of Nursing (Management)",
  "Deputy General Manager / Chief Operating Officer",
  "Deputy Workshop Manager",
  "Derivatives Trader",
  "Derivatives Trading Manager / Senior Derivatives Trader",
  "Description",
  "Description Of Unique Skill.",
  "Design",
  "Design And Engineering",
  "Design And Engineering / Production Engineering",
  "Design Coach/Design Accelerator",
  "Design Engineer",
  "Design Facilitator",
  "Design Production Manager",
  "Design Project Manager",
  "Design Researcher",
  "Design Section Manager",
  "Design Section Manager / Head Of Department",
  "Designer",
  "Designer (Engineering Design)",
  "Desk Head (Chartering)",
  "Desk Head (Sales And Purchase)",
  "Devops Engineer",
  "Digital And Data Analytics",
  "Digital Asset Librarian",
  "Digital Asset Manager",
  "Digital Delivery Management",
  "Digital Transformation Executive",
  "Digital Transformation Manager",
  "Director",
  "Director (Engineering)",
  "Director (Operations And Maintenance)",
  "Director (Project Financing)",
  "Director Of Nursing (Clinical)",
  "Director Of Nursing (Education)",
  "Director Of Nursing (Management)",
  "Director Of Operations / Plant Manager",
  "Director Of Photography (Specialty Camera Operation)",
  "Director Of Revenue Management",
  "Director Of Sales And Marketing",
  "Discipline Engineer",
  "Distributed Generation",
  "Duty Terminal Manager",
  "E-Commerce (Omni-Channel)",
  "E-Commerce Associate / Assistant",
  "E-Commerce Director",
  "E-Commerce Executive",
  "E-Commerce Manager",
  "Early Childhood",
  "Early Childhood Education",
  "Early Intervention",
  "Early Intervention Educator",
  "Early Intervention Teacher",
  "Early Intervention Teaching",
  "Early Years Educators",
  "Economist",
  "Edge Connectivity And Solution Engineer",
  "Education And Programmes Executive",
  "Electricity Imports",
  "Electricity Transmission And Distribution",
  "Electronics",
  "Embedded Systems Engineer",
  "Embedded Systems Engineering Manager",
  "Emergency Medical Technician",
  "Emerging Skills",
  "Employee Experience And Relations",
  "Energy And Chemicals",
  "Energy And Power",
  "Energy Retail",
  "Energy Trading And Portfolio Management",
  "Energy Trading And Portfolio Management Department Manager",
  "Energy Trading Manager",
  "Energy Trading Trader",
  "Engine Driver",
  "Engineer",
  "Engineer (Engineering Design)",
  "Engineer (Engineering Procurement)",
  "Engineer (Project Development)",
  "Engineer - Linear Media Infrastructure",
  "Engineer / Assistant Engineer",
  "Engineer / Engineering Manager / Maintenance Manager",
  "Engineer / Supervisor (Commissioning)",
  "Engineer / Supervisor (Engineering Construction)",
  "Engineer / Supervisor (Operations And Maintenance)",
  "Engineering And Maintenance",
  "Engineering And Maintenance Department Manager",
  "Engineering And Maintenance Director",
  "Engineering And Maintenance Engineer",
  "Engineering And Maintenance Manager",
  "Engineering And Maintenance Principal / Senior Engineer",
  "Engineering And Maintenance Principal Engineer",
  "Engineering And Maintenance Senior Technical Officer",
  "Engineering And Maintenance Senior Technician",
  "Engineering And Maintenance Supervisor",
  "Engineering And Maintenance Technical Officer",
  "Engineering And Maintenance Technician",
  "Engineering Construction And Commissioning",
  "Engineering Consultancy And Design",
  "Engineering Design",
  "Engineering Head (Automatic Fare Collection)",
  "Engineering Head (Mechanical And Electrical)",
  "Engineering Head (Permanent Way And Civil Structure)",
  "Engineering Head (Power)",
  "Engineering Head (Rolling Stock / Engineering Train)",
  "Engineering Head (Signal And Communications)",
  "Engineering Manager",
  "Engineering Procurement",
  "Engineering Service Manager / Technical Service Manager",
  "Engineering Services",
  "Enrolled Nurse",
  "Enterprise Architect",
  "Enterprise Risk Management",
  "Enterprise Risk Management Manager",
  "Environment, Health And Safety",
  "Environment, Health And Safety Manager",
  "Environment, Health And Safety Specialist",
  "Environmental Services",
  "Equipment Engineer",
  "Equipment Specialist",
  "Ess Project Development Engineer",
  "Event Executive / Project Executive",
  "Event Management And Operations",
  "Event Manager / Project Manager",
  "Event Operations Director",
  "Event Operations Executive",
  "Event Operations Manager",
  "Event Services Director",
  "Event Services Executive",
  "Event Services Manager",
  "Execution Trader",
  "Executive (Baggage Services)",
  "Executive (Cargo)",
  "Executive (Flight Operations)",
  "Executive (Ground Services)",
  "Executive (Load Control)",
  "Executive (Passenger Services)",
  "Executive (Production / Catering-Cabin)",
  "Executive (Project Financing)",
  "Executive (Ramp / Technical Ramp)",
  "Executive (Technical Services)",
  "Executive - Content Acquisition",
  "Executive - Content Commissioning",
  "Executive - Localisation",
  "Executive - On-Demand Media Technology And Operations",
  "Executive - Programme Planning And Scheduling",
  "Executive - Standards And Practices",
  "Executive / Service Supervisor",
  "Executive Chef",
  "Executive Director",
  "Executive Housekeeper / Director Of Housekeeping",
  "Executive Pastry Chef",
  "Executive Producer - Broadcast",
  "Executive Producer - Film",
  "Executive Sous Chef",
  "Executive, Performance And Rewards",
  "Exhibition Producer / Conference Producer / Meeting Planner",
  "Facilities Engineer",
  "Facilities Management",
  "Facilities Manager / Facilities Engineer",
  "Facilities Technician",
  "Factory Manager",
  "Family Office",
  "Family Office Advisor - Private Banking",
  "Family Office Executive",
  "Family Office Management Professional",
  "Farm Manager",
  "Farm Worker",
  "Feedstock Supply Trader",
  "Fellow / Senior Fellow",
  "Field",
  "Finance And Regulations",
  "Finance Manager",
  "Financial Accounting",
  "Financial Accounting / Management Accounting",
  "Financial Controller",
  "Financial Crime Compliance Executive",
  "Financial Crime Compliance Manager",
  "Financial Forensics",
  "Financial Forensics Director / Financial Forensics Partner",
  "Financial Forensics Manager",
  "Financial Intermediation",
  "Financial Planning And Analysis Manager",
  "Financial Services",
  "First Officer",
  "Fleet Management",
  "Flight Controller",
  "Flight Operations (Agh)",
  "Flight Operations (Ago)",
  "Flight Operations Assistant",
  "Flight Operations Officer",
  "Floor Manager",
  "Food And Beverage Service",
  "Food Application Scientist And Technologist",
  "Food Biotechnologist",
  "Food Manufacturing",
  "Food Manufacturing Nutritionist",
  "Food Services",
  "Food Technologist",
  "Foreman / Operations Manager / Programme Manager",
  "Forensics Investigation Manager",
  "Forensics Investigator",
  "Freight Forwarding And Operations",
  "Freight Inspector / Incoming Quality Inspector",
  "Freight Officer",
  "Front End Developer",
  "Front Office",
  "Front Office / Housekeeping",
  "Front Office Manager / Operations Manager",
  "Fuel System Operations Executive",
  "Full Stack Developer",
  "Gaffer",
  "Game Design",
  "Game Director",
  "Game Production",
  "Game Sound Designer",
  "Game Technical Development",
  "Game Technical Director",
  "Gas Systems Operations",
  "Gas Systems Operations Engineer",
  "Gas Systems Operations Manager",
  "Gas Systems Operations Principal Engineer",
  "Gas Systems Operations Senior Technical Officer",
  "Gas Systems Operations Technical Officer",
  "Gas Transmission And Distribution",
  "Gas Transmission And Distribution Department Manager",
  "General Cleaner",
  "General Counsel",
  "General Crew",
  "General Management",
  "General Manager",
  "General Manager / Site Director / Vice President",
  "General Worker / Operator",
  "Generated Distribution",
  "Genetic Counselling",
  "Genetic Counselling Associate",
  "Governance And Infrastructure",
  "Grip / Lighting Technician",
  "Ground Services",
  "Ground Services Officer",
  "Group Beverage Manager",
  "Group Data Protection Officer",
  "Guest Service Crew",
  "Guide",
  "Harbour Pilot",
  "Head - Analytics And Customer Insights",
  "Head - Content",
  "Head - Content Acquisition",
  "Head - Content Commissioning",
  "Head - Programme Planning And Scheduling",
  "Head - Technology And Operations",
  "Head Baker",
  "Head Barista",
  "Head Bartender",
  "Head Butler / Butler Manager / Club Floor Manager",
  "Head Chef",
  "Head Horticulturist",
  "Head Keeper / Head Aquarist",
  "Head Of (Specialised) Department",
  "Head Of Branch Management",
  "Head Of Business Development",
  "Head Of Business Development - Brokers",
  "Head Of Business Management",
  "Head Of Business Management (Investment Banking)",
  "Head Of Capacity Management",
  "Head Of Chartering",
  "Head Of Claims",
  "Head Of Claims Liaison",
  "Head Of Client Implementation",
  "Head Of Client Investment Performance And Reporting",
  "Head Of Client Management / Head Of Account Management",
  "Head Of Client Service / Client Support Services Director",
  "Head Of Commodities Trading",
  "Head Of Compliance",
  "Head Of Content And Experience Development / Senior Curator",
  "Head Of Credit",
  "Head Of Credit Risk Management",
  "Head Of Credit Risk Management (Corporate Banking)",
  "Head Of Credit Risk Management (Investment Banking)",
  "Head Of Credit Risk Management (Retail Banking)",
  "Head Of Customer Experience / Head Of User Experience",
  "Head Of Customer Service",
  "Head Of Data Analytics",
  "Head Of Data Science And Artificial Intelligence",
  "Head Of Department",
  "Head Of Derivatives Trading",
  "Head Of Design Production",
  "Head Of Digital Transformation",
  "Head Of Education And Programmes",
  "Head Of Engineering",
  "Head Of Financial Crime Compliance",
  "Head Of Infrastructure",
  "Head Of Innovation And Process Excellence",
  "Head Of It Audit",
  "Head Of Legal",
  "Head Of Marine Claims",
  "Head Of Market And Liquidity Risk Management",
  "Head Of Marketing",
  "Head Of Marketing / Marketing Director",
  "Head Of Network Planning",
  "Head Of Operational Risk Management",
  "Head Of Operational Risk Management (Corporate Banking)",
  "Head Of Operational Risk Management (Insurance)",
  "Head Of Operational Risk Management (Investment Banking)",
  "Head Of Operational Risk Management (Retail Banking)",
  "Head Of Operations",
  "Head Of Operations And Support",
  "Head Of Operations Risk And Control",
  "Head Of Pilotage",
  "Head Of Placement",
  "Head Of Port Business Development / Operations",
  "Head Of Portfolio Management",
  "Head Of Procurement / Head Of Sourcing",
  "Head Of Product",
  "Head Of Product Analytics",
  "Head Of Product Design",
  "Head Of Product Desk / Head Of Product Sales",
  "Head Of Product Management",
  "Head Of Product Management (Asset Management)",
  "Head Of Product Management (Corporate Banking)",
  "Head Of Product Management (Insurance)",
  "Head Of Product Management (Investment Banking)",
  "Head Of Product Management (Retail Banking)",
  "Head Of Product Marketing",
  "Head Of Product Marketing (Asset Management)",
  "Head Of Product Marketing (Insurance)",
  "Head Of Product Marketing (Investment Banking)",
  "Head Of Product Marketing (Retail Banking)",
  "Head Of Product Origination And Structuring",
  "Head Of Projects/Head Of Products",
  "Head Of Quality",
  "Head Of Quality & Risk",
  "Head Of Regulations And Trade Controls",
  "Head Of Reserving And Pricing Actuarial",
  "Head Of Risk",
  "Head Of Risk Analytics / Head Of Compliance Analytics",
  "Head Of Risk Strategy",
  "Head Of Sales",
  "Head Of Sales / Sales Director",
  "Head Of Sales And Distribution / Head Of Coverage",
  "Head Of Segments",
  "Head Of Software Engineering",
  "Head Of Strategy",
  "Head Of Strategy / Head Of Investment Strategy",
  "Head Of Strategy And Analysis",
  "Head Of Sustainability",
  "Head Of Sustainability Risk",
  "Head Of Trade Finance",
  "Head Of Trade Management",
  "Head Of Transformation",
  "Head Of Treasury",
  "Head Of Trust Administration",
  "Head Of Underwriting",
  "Head Of Vessel Operations / Director Of Operations",
  "Head Of Vessel Stowage",
  "Head Of Wealth Planning / Director Of Wealth Planning",
  "Head Scriptwriter",
  "Head Sommelier / Sommelier",
  "Head, Employee Experience And Relations",
  "Head, Hr Business Partner",
  "Head, Learning And Organisation Development",
  "Head, Operations And Technology",
  "Head, Operations Control Centre",
  "Head, Performance And Rewards",
  "Head, Talent Attraction",
  "Head, Talent Management",
  "Health, Safety And Environment (Hse)",
  "Health, Safety And Environmental Coordinator",
  "Health, Safety And Environmental Manager",
  "Health, Safety And Environmental Officer",
  "Healthcare",
  "Healthcare Assistant / Basic Care Assistant / Nursing Aide",
  "Helmsman",
  "Horticulture And Turf Maintenance",
  "Horticulturist",
  "Host / Hostess / Crew Leader",
  "Hotel And Accommodation Services",
  "Housekeeping",
  "Housekeeping Coordinator",
  "Hr Business Partner",
  "Hr Business Partner / Hr Manager",
  "Hse Manager",
  "Hse Specialist",
  "Hsseq Executive",
  "Hsseq Manager",
  "Hsseq Superintendent",
  "Hub Coordinator / Shipping Clerk",
  "Human Resource",
  "Hvdc Building Specialist",
  "Hvdc Infrastructure Specialist",
  "Hvdc Operations And Maintenance Specialist",
  "Hvdc System Integration Engineer",
  "Import Export Administrative Assistant / Shipping Assistant",
  "In Accordance With Building Control Act",
  "In Accordance With: Airlines' Load And Trim Certification",
  "In Accordance With: Control Of Vectors And Pesticides Act",
  "In Accordance With: Dental Registration Act",
  "In Accordance With: Gas Service Worker Licence",
  "In Accordance With: Gas Service Worker License (Restricted)",
  "In Accordance With: Harbour Pilot Licence Class A/B/C",
  "In Accordance With: Healthcare Services Act",
  "In Accordance With: Nurses And Midwives Act (Chapter 209)",
  "In Accordance With: Work At Height Certification",
  "In Accordance With: Workplace Safety And Health (Wsh) Act",
  "In Accordance With: Workplace Safety And Health Act",
  "Incident Investigation Manager",
  "Incident Investigator",
  "Incoming Quality Coordinator / Tally Assistant",
  "Industry Development",
  "Industry Development Director / Assistant Director",
  "Industry Development Manager / Assistant Manager",
  "Industry Development Senior Executive / Executive",
  "Infant Educator",
  "Infocomm Technology",
  "Infrastructure",
  "Infrastructure Architect",
  "Infrastructure Engineer",
  "Infrastructure Engineering Manager",
  "Infrastructure Support Engineer",
  "Innovation",
  "Innovation And Process Excellence Manager",
  "Innovation Executive",
  "Installation, Inspection And Servicing Engineer",
  "Installation, Inspection And Servicing Manager",
  "Installation, Inspection And Servicing Technical Officer",
  "Insurer For Decarbonisation Projects",
  "Integration Engineer",
  "Intellectual Property",
  "Interchange Manager",
  "Internal Audit",
  "Internal Audit Assistant Manager",
  "Internal Audit Senior Manager / Internal Audit Manager",
  "Internationalisation",
  "Internationalisation Director / Assistant Director",
  "Internationalisation Manager / Assistant Manager",
  "Internationalisation Senior Executive / Executive",
  "Investment Counsellor",
  "Investment Counsellor Assistant",
  "Investment Counsellor Team Lead",
  "Ip Director / Ip Strategist",
  "Ip Legal",
  "Ip Legal / Patents Prosecution / Ip Strategy",
  "Ip Paralegal / Ip Executive",
  "Ip Strategy",
  "It Audit Manager",
  "It Auditor",
  "It Business Solutions Manager / Digital Services Manager",
  "Item",
  "Junior Designer",
  "Junior Designer (Engineering Design)",
  "Junior Grip / Junior Lighting Technician",
  "Junior Maintenance Technician",
  "Junior Process Technician",
  "Junior Programmer",
  "Junior Scriptwriter / Junior Writer",
  "Keeper / Aquarist",
  "Key Grip",
  "Know Your Customer / Customer Due Diligence Analyst",
  "Know Your Customer / Customer Due Diligence Manager",
  "Laboratory Assistant",
  "Laboratory Chemist",
  "Laboratory Supervisor",
  "Laboratory Technician / Technologist",
  "Landscape",
  "Landscape Architect",
  "Landscape Design",
  "Landscape Designer",
  "Landscape Implementation",
  "Landscape Manager",
  "Landscape Project Coordinator",
  "Landscape Project Manager",
  "Landscape Technician",
  "Landscape Worker (Nursery Work, Arboriculture)",
  "Laundry Manager",
  "Lead (Digital Delivery)",
  "Lead 2D Artist",
  "Lead 3D Artist (Live-Action Visual Effects)",
  "Lead Animator",
  "Lead Creative Technologist",
  "Lead Design Researcher",
  "Lead Designer",
  "Lead Early Intervention Educator",
  "Lead Early Intervention Teacher",
  "Lead Early Years Educators",
  "Lead Engineer",
  "Lead Engineer / Principal Engineer",
  "Lead Game Designer",
  "Lead Game Programmer",
  "Lead Learning Support Educator",
  "Lead Maintenance Engineer",
  "Lead Plan Approval Engineer",
  "Lead Preschool Educator",
  "Lead Product Analyst",
  "Lead Product Designer",
  "Lead Product Manager",
  "Lead Quality Assurance Tester",
  "Lead Service Designer/Lead Experience Designer",
  "Lead Social Worker",
  "Lead Strategist/Lead Business Designer",
  "Lead Technical Artist",
  "Lead Ui Designer",
  "Lead Ux Designer",
  "Lead Visualiser/Lead Storyteller",
  "Lead Workplace Safety And Health Auditor",
  "Lead Youth Worker",
  "Learning And Development Specialist",
  "Learning And Development Superintendent",
  "Learning And Operations Manager",
  "Learning And Organisation Development",
  "Learning Consultant / Learning Solutionist",
  "Learning Facilitator",
  "Learning Management",
  "Learning Quality Manager",
  "Learning Support",
  "Learning Support Educator",
  "Learning Support Executive",
  "Learning Systems Manager",
  "Learning Technology Designer",
  "Legal And Insurance",
  "Legal Counsel",
  "Legal Services",
  "Licensed Aircraft Engineer - Cat B1 (Mechanical)",
  "Licensed Aircraft Engineer - Cat B2 (Avionics)",
  "Licensed Aircraft Engineer - Cat C",
  "Lifting Supervisor",
  "Lighting Designer",
  "Lighting Specialist",
  "Lighting Specialist (Lighting Programmer)",
  "Lighting Specialist (Master Electrician)",
  "Lighting Technician",
  "Line Producer - Film",
  "Linen Room Attendant / Laundry Valet Attendant",
  "Linen Room Supervisor",
  "Liquefied Natural Gas Trading And Research",
  "Lng Research Analyst",
  "Lng Trading And Research Head",
  "Lng Trading Trader",
  "Load Control Assistant",
  "Load Control Officer",
  "Load Control Services",
  "Logistics",
  "Logistics Contracts Analyst / Logistics Operations Analyst",
  "Logistics Contracts Manager / Logistics Programme Manager",
  "Logistics Process Improvement And Information System",
  "Logistics Solutioning And Programme Management",
  "Logistics Solutions Analyst",
  "Logistics Solutions Manager",
  "Machinist / Technician",
  "Maintenance Manager",
  "Maintenance Planner",
  "Maintenance Supervisor",
  "Maintenance Technician",
  "Make-Up And / Or Hair Artist",
  "Make-Up And / Or Hair Designer",
  "Management",
  "Management Accounting",
  "Manager (Airside Operations)",
  "Manager (Baggage Services)",
  "Manager (Cargo)",
  "Manager (Engineering Procurement)",
  "Manager (Flight Operations)",
  "Manager (Ground Services)",
  "Manager (Load Control)",
  "Manager (Network Planning)",
  "Manager (Passenger Services)",
  "Manager (Production / Catering-Cabin)",
  "Manager (Project Development)",
  "Manager (Project Financing)",
  "Manager (Ramp / Technical Ramp)",
  "Manager (Technical Services)",
  "Manager - Analytics And Customer Insights",
  "Manager - Content Acquisition",
  "Manager - Content Commissioning",
  "Manager - Linear Media Infrastructure",
  "Manager - Linear Media Operations",
  "Manager - Localisation",
  "Manager - On-Demand Media Technology And Operations",
  "Manager - Programme Planning And Scheduling",
  "Manager - Standards And Practices",
  "Manager / Assistant Manager",
  "Manager / Senior Manager",
  "Manager, Employee Experience And Relations",
  "Manager, Learning And Organisation Development",
  "Manager, Operations And Technology",
  "Manager, Performance And Rewards",
  "Manager, Talent Attraction",
  "Manager, Talent Management",
  "Managing Director",
  "Managing Director / General Manager / Vice-President",
  "Manufacturing",
  "Manufacturing Engineer / Production Engineer (Assembly)",
  "Manufacturing Manager",
  "Manufacturing Planning Assistant",
  "Manufacturing Planning Executive",
  "Manufacturing Planning Manager",
  "Manufacturing Planning Supervisor",
  "Marine And Offshore",
  "Marine Claims Executive",
  "Marine Consultant",
  "Marine Manager",
  "Marine Underwriter",
  "Marine Underwriting Assistant",
  "Maritime Services",
  "Market And Liquidity Risk Analyst",
  "Market And Liquidity Risk Manager",
  "Marketing",
  "Marketing And Channel Management Senior Executive",
  "Marketing Assistant / Marketing Coordinator",
  "Marketing Associate / Assistant",
  "Marketing Development Manager",
  "Marketing Director",
  "Marketing Executive",
  "Marketing Manager",
  "Marketing, Business Development And Analysis",
  "Master (Special Limit)",
  "Master Artist Educator",
  "Master Craftsman",
  "Master Engineer (Special Limit)",
  "Master Social Worker",
  "Master Technical Specialist",
  "Materials Recovery",
  "Mechanical Engineer / Electrical Engineer",
  "Media",
  "Media Business Management",
  "Media Technology And Operations",
  "Membership",
  "Membership Crew",
  "Membership Director / Assistant Director",
  "Membership Manager / Assistant Manager",
  "Membership Senior Executive / Executive",
  "Merchandising",
  "Merchandising Associate / Assistant",
  "Merchandising Director",
  "Mergers And Acquisitions",
  "Mergers And Acquisitions Manager",
  "Monitoring, Surveillance And Testing Executive",
  "Monitoring, Surveillance And Testing Manager",
  "Multi-Outlet Manager",
  "Multi-Skilled Cleaner / Team Leader",
  "Multi-Utility Operations Engineer",
  "Multi-Utility Operations Senior Technical Officer",
  "Multi-Utility Operations Shift Manager",
  "Multi-Utility Operations Team Leader",
  "Multi-Utility Operations Technical Officer",
  "Multi-Utility Operations Technician",
  "Multimedia Designer",
  "Multimedia Specialist",
  "Multimedia Specialist (Network Engineer)",
  "Multimedia Technician",
  "Ndt Level 3 Engineer (Aircraft Maintenance)",
  "Ndt Level 3 Engineer (Manufacturing)",
  "Network Development Engineer",
  "Network Development Manager",
  "Network Development Principal Engineer",
  "Network Development Senior Technical Officer",
  "Network Development Technical Officer",
  "Network Development Technician",
  "Network Engineer",
  "Network Planner",
  "Network Planning",
  "Network Planning Analyst",
  "Network Planning And Strategy Engineer",
  "Network Planning And Strategy Manager",
  "Network Planning And Strategy Principal Engineer",
  "Network Planning And Strategy Senior Technical Officer",
  "Network Planning And Strategy Technical Officer",
  "Network Planning Manager",
  "Nurse Clinician",
  "Nurse Educator",
  "Nurse Manager",
  "Nursery",
  "Nursery Manager",
  "Nursery Supervisor / Nursery Team Leader",
  "Nursery Technician",
  "Nursing",
  "Occupational Hygiene Officer",
  "Occupational Hygienist",
  "Occupational Therapist",
  "Occupational Therapy",
  "Officer (Flight Control)",
  "Officer Commanding / Operations Manager",
  "Operation Specialist",
  "Operational Control",
  "Operational Risk Analyst",
  "Operational Risk Analyst (Corporate Banking)",
  "Operational Risk Analyst (Insurance)",
  "Operational Risk Analyst (Investment Banking)",
  "Operational Risk Analyst (Retail Banking)",
  "Operational Risk Assistant",
  "Operational Risk Assistant (Corporate Banking)",
  "Operational Risk Assistant (Insurance)",
  "Operational Risk Assistant (Investment Banking)",
  "Operational Risk Assistant (Retail Banking)",
  "Operational Risk Manager",
  "Operational Risk Manager (Corporate Banking)",
  "Operational Risk Manager (Insurance)",
  "Operational Risk Manager (Investment Banking)",
  "Operational Risk Manager (Retail Banking)",
  "Operations",
  "Operations And Maintenance",
  "Operations And Maintenance Engineer",
  "Operations And Maintenance Manager",
  "Operations And Maintenance Principal Engineer",
  "Operations And Maintenance Senior Technical Officer",
  "Operations And Maintenance Technical Officer",
  "Operations And Maintenance Technician",
  "Operations And Support",
  "Operations And Support Manager",
  "Operations And Technology",
  "Operations Assistant / Operations Coordinator",
  "Operations Centre Support Engineer",
  "Operations Control Centre Manager",
  "Operations Crew",
  "Operations Director / General Manager",
  "Operations Director / Operations Manager",
  "Operations Director / Retail Manager / Operations Manager",
  "Operations Executive",
  "Operations Executive / Operations Supervisor",
  "Operations Manager",
  "Operations Manager (Fleet Management)",
  "Operations Manager / Production Manager",
  "Operations Risk And Control Analyst",
  "Operations Risk And Control Manager",
  "Operations, Procurement And Sourcing",
  "Operator",
  "Operator - Linear Media Operations",
  "Optimisation Engineer",
  "Oral Health Therapy",
  "Outlet Manager / Assistant Outlet Manager",
  "Paralegal / Legal Executive",
  "Partner (Corporate)",
  "Partner (Disputes)",
  "Partner / Director / Counsel",
  "Partner / Director / Principal",
  "Passenger Services",
  "Pastry And Baking",
  "Pastry Chef",
  "Pastry Cook",
  "Patent Attorney Trainee / Patent Agent Trainee",
  "Patents Prosecution",
  "Patient Service Assistant Supervisor",
  "Patient Service Associate",
  "Patient Service Executive",
  "Patient Service Senior Associate",
  "Patient Service Supervisor",
  "Perform In Accordance With Wsh Act",
  "Performance And Rewards",
  "Pest Control Manager",
  "Pest Control Supervisor",
  "Pest Control Technician",
  "Pest Control Worker",
  "Pest Management",
  "Pharmacy Support",
  "Pharmacy Technician",
  "Pharmacy Technician Executive (Patient Care Services)",
  "Physiotherapist",
  "Physiotherapy",
  "Pilot Operations",
  "Placement Executive",
  "Placement Manager",
  "Plan Approval Engineer",
  "Planning Assistant (Aircraft Maintenance)",
  "Planning Assistant (Fleet Management)",
  "Planning Executive (Aircraft Maintenance)",
  "Planning Executive (Fleet Management)",
  "Planning Manager (Aircraft Engine / Component Maintenance)",
  "Planning Manager (Aircraft Maintenance)",
  "Planning Manager (Fleet Management)",
  "Planning Supervisor (Aircraft Maintenance)",
  "Planning Supervisor (Fleet Management)",
  "Plant Manager",
  "Policy Officer",
  "Port",
  "Port Business Development / Operations Manager",
  "Portfolio Management Analyst",
  "Portfolio Management Manager",
  "Portfolio Manager / Investment Manager / Fund Manager",
  "Post-Production Assistant",
  "Post-Production Supervisor",
  "Power Generation",
  "Power System Engineer",
  "Pre-Sales Consultant",
  "Pre-Sales Director",
  "Precision Engineering",
  "Prehospital Emergency Care",
  "Preschool Educator",
  "Pricing Actuarial Executive",
  "Principal Chemist",
  "Principal Counsellor",
  "Principal Creative Technologist",
  "Principal Design Researcher",
  "Principal Designer",
  "Principal Engineer",
  "Principal Engineer (Engineering)",
  "Principal Engineer (Technology)",
  "Principal Engineer / Engineering Manager (Power)",
  "Principal Engineer / Engineering Manager (Rolling Stock)",
  "Principal Engineer / Manager (Commissioning)",
  "Principal Engineer / Manager (Engineering Construction)",
  "Principal Engineer / Manager (Engineering Design)",
  "Principal Engineer / Manager (Operations And Maintenance)",
  "Principal Enrolled Nurse",
  "Principal Landscape Architect",
  "Principal Landscape Designer",
  "Principal Marine Consultant",
  "Principal Marine Surveyor",
  "Principal Occupational Therapist (Clinical)",
  "Principal Occupational Therapy Educator",
  "Principal Occupational Therapy Manager",
  "Principal Occupational Therapy Researcher",
  "Principal Physiotherapist (Clinical)",
  "Principal Physiotherapy Educator",
  "Principal Physiotherapy Manager",
  "Principal Physiotherapy Researcher",
  "Principal Psychologist",
  "Principal Psychologist Educator",
  "Principal Research Counsellor",
  "Principal Research Psychologist",
  "Principal Security Consultant",
  "Principal Service Designer/Principal Experience Designer",
  "Principal Speech Therapist (Clinical)",
  "Principal Speech Therapy Educator",
  "Principal Speech Therapy Manager",
  "Principal Speech Therapy Researcher",
  "Private Security",
  "Process Development / Ms&T Director",
  "Process Development / Ms&T Engineer",
  "Process Development / Ms&T Manager",
  "Process Development / Ms&T Senior Engineer",
  "Process Engineer",
  "Process Engineering Manager",
  "Process Safety Engineer",
  "Process Specialist / Shift Leader / Team Leader",
  "Process Technician",
  "Process Technician / Maintenance Technician",
  "Procurement Coordinator / Procurement Executive",
  "Procurement Executive / Sourcing Executive",
  "Procurement Manager",
  "Procurement Manager / Sourcing Manager",
  "Producer",
  "Producer - Broadcast (Casting)",
  "Producer - Film (Casting)",
  "Producer - Games",
  "Product Analyst",
  "Product Analyst (Asset Management)",
  "Product Analyst (Corporate Banking)",
  "Product Analyst (Insurance)",
  "Product Analyst (Investment Banking)",
  "Product Analyst (Private Banking And Wealth Management)",
  "Product Analyst (Retail Banking)",
  "Product And Experience Development Director",
  "Product And Experience Development Executive",
  "Product And Experience Development Manager",
  "Product And Pricing Senior Executive",
  "Product Designer",
  "Product Development",
  "Product Development Analyst",
  "Product Development Analyst (Asset Management)",
  "Product Development Analyst (Corporate Banking)",
  "Product Development Analyst (Insurance)",
  "Product Development Analyst (Investment Banking)",
  "Product Development Analyst (Retail Banking)",
  "Product Development Manager",
  "Product Development Manager (Asset Management)",
  "Product Development Manager (Corporate Banking)",
  "Product Development Manager (Insurance)",
  "Product Development Manager (Investment Banking)",
  "Product Development Manager (Retail Banking)",
  "Product Engineer",
  "Product Engineer / Product Designer",
  "Product Manager",
  "Product Manager (Asset Management)",
  "Product Manager (Corporate Banking)",
  "Product Manager (Insurance)",
  "Product Manager (Investment Banking)",
  "Product Manager (Private Banking And Wealth Management)",
  "Product Manager (Retail Banking)",
  "Product Marketing Executive",
  "Product Marketing Executive (Asset Management)",
  "Product Marketing Executive (Insurance)",
  "Product Marketing Executive (Investment Banking)",
  "Product Marketing Executive (Retail Banking)",
  "Product Marketing Manager",
  "Product Marketing Manager (Asset Management)",
  "Product Marketing Manager (Insurance)",
  "Product Marketing Manager (Investment Banking)",
  "Product Marketing Manager (Retail Banking)",
  "Product Origination And Structuring Analyst",
  "Product Origination And Structuring Manager",
  "Product Risk Analyst",
  "Product Risk Manager",
  "Product Security Engineer",
  "Product Security Engineering Manager",
  "Product Solutioning And Management",
  "Product Specialist / Product Sales Specialist",
  "Product Technologist / Innovation Manager",
  "Production",
  "Production And Process Engineering",
  "Production Assistant",
  "Production Coordinator",
  "Production Director",
  "Production Engineer",
  "Production Engineer / Biotechnologist",
  "Production Engineering",
  "Production Executive",
  "Production Manager",
  "Production Manager (Location Scouting)",
  "Production Manager / Assistant Production Manager",
  "Production Operator",
  "Production Planner",
  "Production Section Manager / Head Of Department",
  "Production Supervisor",
  "Production Team Supervisor",
  "Production Technical Services",
  "Proficiency Level Of Skill From Skills Framework.",
  "Proficiency_Level",
  "Program Director",
  "Program Manager",
  "Programme Coordinator / Programme Executive",
  "Programme Director",
  "Programme Director / Senior Operations Manager",
  "Programme Manager",
  "Project Coordination Engineer",
  "Project Coordination Manager",
  "Project Development",
  "Project Director",
  "Project Director (Construction)",
  "Project Director (Project Management)",
  "Project Engineer",
  "Project Executive",
  "Project Financing",
  "Project Management",
  "Project Manager",
  "Project Manager / Scrum Master",
  "Project Supervisor",
  "Prop Designer",
  "Prop Supervisor",
  "Psychologist",
  "Psychology",
  "Public Transport",
  "Qa Engineer",
  "Qa&Qc Manager",
  "Quality Assurance",
  "Quality Assurance / Quality Control Engineer",
  "Quality Assurance / Quality Control Manager",
  "Quality Assurance And Control",
  "Quality Assurance And Quality Control (Qa&Qc)",
  "Quality Assurance And Quality Control Director",
  "Quality Assurance And Quality Control Manager",
  "Quality Assurance Assistant",
  "Quality Assurance Engineer",
  "Quality Assurance Manager",
  "Quality Assurance Senior Specialist",
  "Quality Assurance Specialist",
  "Quality Assurance Supervisor / Quality Control Supervisor",
  "Quality Assurance Tester",
  "Quality Control Assistant Laboratory Analyst",
  "Quality Control Manager",
  "Quality Engineer",
  "Quality Engineer (Aircraft Engine / Component Maintenance)",
  "Quality Engineer (Aircraft Maintenance)",
  "Quality Engineer (Fleet Management)",
  "Quality Engineer (Manufacturing)",
  "Quality Engineering Manager",
  "Quality Manager (Aircraft Engine / Component Maintenance)",
  "Quality Manager (Aircraft Maintenance)",
  "Quality Manager (Fleet Management)",
  "Quality Manager (Manufacturing)",
  "Quantitative Trader",
  "Quantity Surveying",
  "Quantity Surveyor / Contracts Manager / Cost Manager",
  "R&D Chemist",
  "R&D Manager",
  "Radio Frequency Engineer",
  "Rail Engineering",
  "Rail Operations",
  "Rail Service Manager",
  "Ramp And Technical Ramp Services",
  "Ramp Officer",
  "Ramp Operator",
  "Regional Manager / Export Manager",
  "Regulations And Trade Controls Manager",
  "Relationship Management Director - Commercial",
  "Relationship Manager - Commercial",
  "Relationship Manager - Private Banking",
  "Relationship Manager - Small And Medium Enterprises",
  "Repair Engineer / Process Engineer",
  "Reporter / Correspondent - News",
  "Research",
  "Research Analyst",
  "Research Analyst (Asset Management)",
  "Research Analyst (Investment Banking)",
  "Research Analyst (Private Banking And Wealth Management)",
  "Research And Development",
  "Research And Development (R&D)",
  "Research And Development Chef",
  "Research Associate",
  "Research Counsellor",
  "Research Director",
  "Research Director / Assistant Director",
  "Research Executive",
  "Research Manager / Assistant Manager",
  "Research Psychologist",
  "Research Senior Analyst / Analyst",
  "Research Technologist",
  "Reservations Executive / Reservations Supervisor",
  "Reservations Manager / Assistant Reservations Manager",
  "Reservations Officer / Reservations Agent",
  "Reserving Actuarial Executive",
  "Reserving And Pricing Actuarial Manager",
  "Restructuring And Insolvency",
  "Restructuring And Insolvency Manager",
  "Retail",
  "Retail Operations",
  "Revenue And Distribution",
  "Revenue Manager / Assistant Revenue Manager",
  "Revenue Specialist / Revenue Analyst",
  "Rigger / Signalman",
  "Risk Analytics Analyst / Compliance Analytics Analyst",
  "Risk Analytics Manager / Compliance Analytics Manager",
  "Risk Manager",
  "Risk Strategy Manager",
  "Risk, Compliance And Legal",
  "Rooms Division Manager / Director Of Rooms",
  "Sales Account Manager",
  "Sales And Customer Service",
  "Sales And Distribution Specialist / Coverage Officer",
  "Sales And Marketing",
  "Sales And Purchase Broker",
  "Sales Assistant / Sales Coordinator",
  "Sales Associate / Brand Associate",
  "Sales Coordinator / Catering Sales Coordinator",
  "Sales Director",
  "Sales Executive",
  "Sales Executive / Catering Sales Executive",
  "Sales Executive / Travel Consultant (Sales)",
  "Sales Manager",
  "Sales Supervisor / Brand Supervisor",
  "Scenic Supervisor",
  "Scriptwriter / Writer",
  "Sea Transport",
  "Section Head / Team Leader / Line Operator",
  "Section Supervisor / Foreman",
  "Sector_Title",
  "Security",
  "Security Architect",
  "Security Consultancy",
  "Security Consultant",
  "Security Officer",
  "Security Operations Analyst",
  "Security Operations Manager",
  "Security Supervisor",
  "Segment Executive",
  "Segment Manager",
  "Senior Animator",
  "Senior Application Chemist",
  "Senior Architect",
  "Senior Architectural Executive",
  "Senior Artificial Intelligence / Machine Learning Engineer",
  "Senior Assistant Director / Assistant Director",
  "Senior Assistant Engineer / Assistant Engineer (Power)",
  "Senior Associate (Corporate)",
  "Senior Associate (Disputes)",
  "Senior Back End Developer",
  "Senior Bus Captain",
  "Senior Care Staff",
  "Senior Centre Leader",
  "Senior Charterer / Charterer",
  "Senior Civil And Structural Engineer",
  "Senior Community Care Associate",
  "Senior Cook / Station Chef",
  "Senior Counsellor",
  "Senior Credit Analyst / Credit Analyst",
  "Senior Data Engineer",
  "Senior Depot Supervisor / Depot Supervisor",
  "Senior Design Engineer",
  "Senior Director / Director",
  "Senior Discipline Engineer",
  "Senior Early Intervention Educator",
  "Senior Early Intervention Teacher",
  "Senior Early Years Educators",
  "Senior Economist",
  "Senior Engine Programmer (Tools Programming)",
  "Senior Engineer",
  "Senior Engineer (Engineering Design)",
  "Senior Engineer (Engineering Procurement)",
  "Senior Engineer / Assistant Manager (Commissioning)",
  "Senior Engineer / Engineer",
  "Senior Engineer / Engineer (Automatic Fare Collection)",
  "Senior Engineer / Engineer (Engineering Train)",
  "Senior Engineer / Engineer (Mechanical And Electrical)",
  "Senior Engineer / Engineer (Power)",
  "Senior Engineer / Engineer (Rolling Stock)",
  "Senior Engineer / Engineer (Signal And Communications)",
  "Senior Enrolled Nurse",
  "Senior Equipment Engineer",
  "Senior Equipment Specialist",
  "Senior Executive (Project Financing)",
  "Senior Executive - Product Management",
  "Senior Facilities Engineer",
  "Senior Facilities Manager",
  "Senior Front End Developer",
  "Senior Full Stack Developer",
  "Senior Game Designer",
  "Senior Game Programmer",
  "Senior Game Sound Designer",
  "Senior Ground Services Officer",
  "Senior Hse Specialist",
  "Senior Infant Educator",
  "Senior Integration Engineer",
  "Senior Interchange Supervisor / Interchange Supervisor",
  "Senior Internal Auditor / Internal Auditor",
  "Senior Ip Legal Associate / Ip Legal Associate",
  "Senior Ip Manager / Ip Manager",
  "Senior Ip Paralegal / Ip Management Associate",
  "Senior Laboratory Chemist",
  "Senior Laboratory Technician / Technologist",
  "Senior Lead Early Intervention Educator",
  "Senior Lead Early Intervention Teacher",
  "Senior Lead Learning Support Educator",
  "Senior Learning Support Educator",
  "Senior Legal Counsel",
  "Senior Level Designer",
  "Senior Machinist / Senior Technician",
  "Senior Maintenance Technician",
  "Senior Manager",
  "Senior Manager / Manager",
  "Senior Manufacturing Planning Executive",
  "Senior Marine Claims Executive",
  "Senior Marine Superintendent / Marine Superintendent",
  "Senior Marine Surveyor / Marine Surveyor",
  "Senior Master Social Worker",
  "Senior Mechanical Engineer / Senior Electrical Engineer",
  "Senior Ndt Level 3 Engineer (Aircraft Maintenance)",
  "Senior Ndt Level 3 Engineer (Manufacturing)",
  "Senior Nurse Clinician",
  "Senior Nurse Educator",
  "Senior Nurse Manager",
  "Senior Occupational Therapist",
  "Senior Operations Manager / Senior Technical Manager",
  "Senior Operator - Linear Media Operations",
  "Senior Pharmacy Technician",
  "Senior Physiotherapist",
  "Senior Plan Approval Engineer",
  "Senior Planning Executive (Aircraft Maintenance)",
  "Senior Planning Executive (Fleet Management)",
  "Senior Preschool Educator",
  "Senior Principal Counsellor",
  "Senior Principal Occupational Therapist (Clinical)",
  "Senior Principal Occupational Therapy Educator",
  "Senior Principal Occupational Therapy Manager",
  "Senior Principal Occupational Therapy Researcher",
  "Senior Principal Physiotherapist (Clinical)",
  "Senior Principal Physiotherapy Educator",
  "Senior Principal Physiotherapy Manager",
  "Senior Principal Physiotherapy Researcher",
  "Senior Principal Psychologist",
  "Senior Principal Psychologist Educator",
  "Senior Principal Research Psychologist",
  "Senior Principal Researcher / Principal Researcher",
  "Senior Principal Speech Therapist (Clinical)",
  "Senior Principal Speech Therapy Educator",
  "Senior Principal Speech Therapy Manager",
  "Senior Principal Speech Therapy Researcher",
  "Senior Process Engineer",
  "Senior Process Safety Engineer",
  "Senior Process Technician",
  "Senior Procurement Executive",
  "Senior Producer / Producer - Current Affairs",
  "Senior Producer / Producer - News",
  "Senior Product Engineer",
  "Senior Product Manager",
  "Senior Production Engineer",
  "Senior Production Manager",
  "Senior Project Engineer",
  "Senior Project Manager",
  "Senior Psychologist",
  "Senior Qa Engineer",
  "Senior Quality Assurance / Quality Control Engineer",
  "Senior Quality Engineer",
  "Senior Quality Engineer (Aircraft Maintenance)",
  "Senior Quality Engineer (Fleet Management)",
  "Senior Quality Engineer (Manufacturing)",
  "Senior R&D Chemist",
  "Senior Repair Engineer / Senior Process Engineer",
  "Senior Research Associate",
  "Senior Research Psychologist",
  "Senior Risk Analyst / Risk Analyst",
  "Senior Security Engineer / Security Engineer",
  "Senior Security Officer",
  "Senior Security Supervisor",
  "Senior Server Programmer",
  "Senior Shipping Analyst",
  "Senior Social Worker",
  "Senior Special Care Oral Health Therapist",
  "Senior Speech Therapist",
  "Senior Staff Nurse",
  "Senior Superintendent",
  "Senior Technical Service Engineer",
  "Senior Technical Service Engineer (Fleet Management)",
  "Senior Technical Specialist",
  "Senior Technical Superintendent / Technical Superintendent",
  "Senior Technician",
  "Senior Technician (Assembly)",
  "Senior Technician (Automatic Fare Collection)",
  "Senior Technician (Avionics)",
  "Senior Technician (Component Repair & Overhaul - Avionics)",
  "Senior Technician (Engineering Train)",
  "Senior Technician (Manufacturing)",
  "Senior Technician (Mechanical And Electrical)",
  "Senior Technician (Mechanical)",
  "Senior Technician (Permanent Way And Civil Structure)",
  "Senior Technician (Power)",
  "Senior Technician (Rolling Stock)",
  "Senior Technician (Signal And Communications)",
  "Senior Technician / Technician",
  "Senior Therapy Assistant",
  "Senior Trade Finance Analyst / Trade Finance Analyst",
  "Senior Train Captain / Train Captain",
  "Senior Treasury Analyst / Treasury Analyst",
  "Senior Vessel Operator / Vessel Operator",
  "Senior Workplace Safety And Health Officer",
  "Senior Workshop Engineer",
  "Senior Youth Worker",
  "Server / Service Crew / Runner",
  "Service Designer/Experience Designer",
  "Service Operations Manager / Duty Operations Manager",
  "Set Designer",
  "Set Designer (Set Decoration, Props Management)",
  "Ship Agency Manager",
  "Ship Agent / Boarding Officer",
  "Ship Captain / Chief Mate",
  "Shipping",
  "Shipping Analyst",
  "Shipping And Maritime Services",
  "Site Director / Head",
  "Site Reliability Engineer",
  "Site Reliability Engineering Manager",
  "Site Supervisor / Trade Supervisor / Project Coordinator",
  "Skill Code From Skills Framework.",
  "Skill_2K_Title",
  "Skill_Description",
  "Skill_Title",
  "Skill_Type",
  "Skills_11K_Title",
  "Smart Grid",
  "Social Service",
  "Social Service Assistant",
  "Social Work",
  "Social Work / Youth Work / Care And Programme",
  "Social Work Associate",
  "Social Worker",
  "Software And Applications",
  "Software Architect",
  "Software Engineer",
  "Software Engineering Manager",
  "Solar Pv And Ess Asset Maintenance Engineer",
  "Solar Pv And Ess Asset Maintenance Senior Technical Officer",
  "Solar Pv And Ess Business Development Senior Executive",
  "Solar Pv And Ess Project Financing Senior Executive",
  "Solar Pv Asset Performance Engineer",
  "Solar Pv Project Development Engineer",
  "Solar Pv Project Development Site Supervisor",
  "Solutions Architect",
  "Sound Designer",
  "Sound Designer (Composer)",
  "Sound Designer (System Designer)",
  "Sound Editor / Sound Engineer",
  "Sound Recordist",
  "Sound Specialist",
  "Sound Specialist (Sound Operator)",
  "Sound Technician",
  "Special Care Oral Health Therapist",
  "Specialist (Digital Delivery)",
  "Speech Therapist",
  "Speech Therapy",
  "Sponsorship Director",
  "Sponsorship Executive",
  "Sponsorship Manager",
  "Staff Engineer / Senior Staff Engineer",
  "Staff Nurse",
  "Stage Manager",
  "Staging Specialist",
  "Staging Specialist (Rigger)",
  "Staging Technician",
  "Station Operations Manager",
  "Steersman",
  "Store Assistant",
  "Store Manager / Outlet Manager",
  "Stowage Manager / Senior Stowage Planner",
  "Stowage Planner / Stowage Coordinator",
  "Strategist/Business Designer",
  "Strategy & Governance",
  "Strategy & Governance Director / Assistant Director",
  "Strategy & Governance Manager / Assistant Manager",
  "Strategy & Governance Senior Executive / Executive",
  "Strategy And Governance",
  "Studio Director / Outside Broadcast Director",
  "Studio Technical Director",
  "Superintendent",
  "Supervising Sound Editor (Sound Mixing)",
  "Supervisor (Baggage Services)",
  "Supervisor (Cargo)",
  "Supervisor (Flight Control) / Supervisor (Crew Scheduling)",
  "Supervisor (Flight Operations)",
  "Supervisor (Ground Services)",
  "Supervisor (Load Control)",
  "Supervisor (Passenger Services)",
  "Supervisor (Production / Catering-Cabin)",
  "Supervisor (Ramp / Technical Ramp)",
  "Supervisor (Technical Services)",
  "Supervisor / Chargehand / Foreman",
  "Supervisor / Production Planner",
  "Supply Chain / Commercial Manager",
  "Sustainability",
  "Sustainability / Environment, Social And Governance Analyst",
  "Sustainability Manager",
  "Sustainability Reporting And Assurance",
  "Sustainability Risk Analyst",
  "Sustainability Risk Manager",
  "Sysops Engineer",
  "System Audit",
  "Systems Support Engineer",
  "Talent Attraction",
  "Talent Attraction / Employee Experience And Relations",
  "Talent Management",
  "Talent Management / Learning And Organisation Development",
  "Tax",
  "Tax Associate / Tax Executive",
  "Tax Manager",
  "Tax Senior / Tax Senior Executive",
  "Teacher Aide",
  "Technical",
  "Technical And Engineering",
  "Technical Artist",
  "Technical Executive",
  "Technical Feasibility Engineer",
  "Technical Manager",
  "Technical Manager/ Director",
  "Technical Officer",
  "Technical Ramp Officer",
  "Technical Service Engineer",
  "Technical Service Engineer (Fleet Management)",
  "Technical Service Manager",
  "Technical Service Manager (Fleet Management)",
  "Technical Services",
  "Technical Services Officer",
  "Technical Services, Application And Product Development",
  "Technical Specialist",
  "Technical Theatre & Production",
  "Technician",
  "Technician (Assembly)",
  "Technician (Automatic Fare Collection)",
  "Technician (Avionics)",
  "Technician (Component Repair & Overhaul - Avionics)",
  "Technician (Component Repair & Overhaul - Mechanical)",
  "Technician (Engine / Engine Component Repair & Overhaul)",
  "Technician (Engineering Train)",
  "Technician (Manufacturing)",
  "Technician (Mechanical And Electrical)",
  "Technician (Mechanical)",
  "Technician (Permanent Way And Civil Structure)",
  "Technician (Power)",
  "Technician (Rolling Stock)",
  "Technician (Signal And Communications)",
  "Technician - Linear Media Infrastructure",
  "Technician / Coordinator (Commissioning)",
  "Technician / Coordinator (Engineering Construction)",
  "Technician / Coordinator (Operations And Maintenance)",
  "Technology",
  "Technology, Information And Cybersecurity Risk Analyst",
  "Technology, Information And Cybersecurity Risk Manager",
  "Terminal Manager",
  "Terminal Operations And Fuel System Operations",
  "Terminal Operations Manager",
  "Terminal Operations Senior Technical Officer",
  "Terminal Operations Technical Officer",
  "Terminal Operations Technician",
  "Therapy Assistant",
  "Therapy Support",
  "Therapy Support Associate",
  "Threat Analysis Manager",
  "Title Of Sector.",
  "Title Of Skill From Skills Framework.",
  "Title Of Unique Skill.",
  "Tour Leader",
  "Tourism",
  "Tourist Guide",
  "Town Gas Plant Maintenance Engineer",
  "Town Gas Plant Maintenance Manager",
  "Town Gas Plant Maintenance Senior Technical Officer",
  "Town Gas Plant Maintenance Technical Officer",
  "Town Gas Plant Maintenance Technician",
  "Town Gas Production And Maintenance",
  "Town Gas Production Engineer",
  "Town Gas Production Manager",
  "Town Gas Production Senior Technical Officer",
  "Town Gas Production Technical Officer",
  "Town Gas Production Technician",
  "Town Gas Technical Services",
  "Town Gas Technical Services Department Manager",
  "Trade Associations And Chambers",
  "Trade Finance Manager",
  "Trade Management Executive",
  "Trade Manager / Assistant Trade Manager",
  "Trader",
  "Trading And Execution",
  "Trading And Sales",
  "Traffic Coordinator / Dispatch Coordinator",
  "Train Operations Manager",
  "Train Service Controller / Depot Traffic Controller",
  "Trainee Aircraft Maintenance Technician",
  "Trainee Maintenance Technician",
  "Trainee Technician",
  "Training And Adult Education",
  "Transaction Banking Operations Analyst",
  "Transaction Banking Operations Analyst (Corporate Banking)",
  "Transaction Banking Operations Manager",
  "Transaction Banking Operations Manager (Corporate Banking)",
  "Transportation Management And Operations",
  "Transportation Operations Manager",
  "Travel Account Director",
  "Travel Account Executive",
  "Travel Account Manager",
  "Travel Management And Operations",
  "Travel Operations Director",
  "Travel Operations Manager",
  "Treasury Manager",
  "Treasury Operations Analyst / Market Operations Analyst",
  "Treasury Operations Manager / Market Operations Manager",
  "Treatment And Disposal",
  "Trust Administrator",
  "Trust Manager",
  "Tsc To Unique Skills Mapping Tab",
  "Tsc_Code",
  "Tug Master",
  "Ui Designer",
  "Underwriting Executive",
  "Underwriting Manager",
  "Unique Skills List Tab",
  "Ux Designer",
  "Venue Management And Operations",
  "Venue Operations Director",
  "Venue Operations Executive",
  "Venue Operations Manager",
  "Vertical Product Manager",
  "Vertical Specialist",
  "Vessel Account Executive",
  "Vessel Accountant",
  "Vessel Cost Controller",
  "Vessel Operations Manager",
  "Vice President",
  "Video Editor (Colour Grading, Online Editing)",
  "Vision Mixer / Switcher",
  "Visual Graphics",
  "Visual Merchandiser",
  "Visual Merchandising Associate / Assistant",
  "Visualiser/Storyteller",
  "Volunteer Executive",
  "Volunteer Manager",
  "Vulnerability Assessment And Penetration Testing Analyst",
  "Vulnerability Assessment And Penetration Testing Manager",
  "Wardrobe Supervisor",
  "Warehouse Management And Operations",
  "Waste And Recyclables Collection Attendant",
  "Waste And Recyclables Collection Executive",
  "Waste And Recyclables Collection Manager",
  "Waste And Recyclables Collection Supervisor",
  "Waste Collection",
  "Waste Management Consultant",
  "Waste Process Engineer",
  "Waste Recycling Executive / Waste Recovery Executive",
  "Waste Recycling Machine Operator",
  "Waste Recycling Manager / Waste Recovery Manager",
  "Waste Recycling Sorter",
  "Waste Recycling Supervisor / Waste Recovery Supervisor",
  "Waste Treatment Executive / Waste Disposal Executive",
  "Waste Treatment Plant Manager",
  "Waste Treatment Supervisor / Waste Disposal Supervisor",
  "Waste Treatment Worker / Waste Disposal Worker",
  "Water Quality Control Chemist",
  "Water Quality Control Manager",
  "Water Quality Control Principal Chemist",
  "Water Quality Control Senior Technical Officer",
  "Water Quality Control Technical Officer",
  "Water Quality Control Technician",
  "Wealth Planner",
  "Weighbridge Operator",
  "Weighbridge Supervisor",
  "Wholesale Trade",
  "Wine Server / Wine Waiter / Commis Sommelier",
  "Wine Specialist / Demi Sommelier",
  "Workplace Safety And Health",
  "Workplace Safety And Health Auditor",
  "Workplace Safety And Health Coordinator",
  "Workplace Safety And Health Manager",
  "Workplace Safety And Health Officer",
  "Workplace Safety And Health Supervisor",
  "Workshop Engineer",
  "Workshop Manager",
  "Workshop Supervisor / Senior Foreman",
  "Youth Work",
  "Youth Work Associate",
  "Youth Worker"
];

export const BUSINESS_CREATION_SKILLS = [
  "Entrepreneurship",
  "Startup development",
  "Business planning",
  "Business strategy",
  "Market research",
  "Competitive analysis",
  "Idea validation",
  "Product market fit",
  "Business model development",
  "Lean startup methodology",
  "Go to market strategy",
  "Revenue modeling",
  "Pricing strategy",
  "Financial planning",
  "Fundraising",
  "Investor relations",
  "Pitch deck creation",
  "Venture capital",
  "Bootstrapping",
  "Business operations",
  "Process optimization",
  "Growth hacking",
  "Customer acquisition",
  "Customer retention",
  "Sales funnel optimization",
  "Conversion rate optimization",
  "Brand building",
  "Personal branding",
  "Public relations",
  "Networking",
  "Partnership development",
  "Negotiation skills",
  "Leadership development",
  "Team building",
  "Hiring strategy",
  "People management",
  "Time prioritization",
  "Decision making strategy",
  "Risk assessment",
  "Problem solving strategy",
  "Adaptability mindset",
  "Innovation management",
  "Product development",
  "Mvp development",
  "User experience strategy",
  "Customer journey mapping",
  "Business analytics",
  "Kpi tracking",
  "Data driven decision making",
  "Legal compliance",
  "Business registration",
  "Intellectual property",
  "Contract management",
  "Supply chain management",
  "Vendor management",
  "Operations scaling",
  "International expansion",
  "Ecommerce strategy",
  "Digital transformation",
  "Automation strategy"
];

